// Silence deprecation, duplicate import, and placeholder configuration warnings globally
if (typeof window !== 'undefined') {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    if (
      typeof args[0] === 'string' &&
      (args[0].includes('THREE.Clock') ||
       args[0].includes('THREE.THREE.Clock') ||
       args[0].includes('Multiple instances of Three.js') ||
       args[0].includes('Autoblocking') ||
       args[0].includes('autoblocking'))
    ) {
      return;
    }
    originalWarn.apply(console, args);
  };

  const originalLog = console.log;
  console.log = (...args) => {
    if (
      typeof args[0] === 'string' &&
      (args[0].includes('Autoblocking') || args[0].includes('autoblocking'))
    ) {
      return;
    }
    originalLog.apply(console, args);
  };

  const originalError = console.error;
  console.error = (...args) => {
    if (
      typeof args[0] === 'string' &&
      (args[0].includes('Autoblocking') || args[0].includes('autoblocking'))
    ) {
      return;
    }
    originalError.apply(console, args);
  };
}

import React from 'react';
import { createRoot } from 'react-dom/client';
import Navbar from './Navbar';

class SiteNavbar extends HTMLElement {
  connectedCallback() {
    this.root = createRoot(this);
    this.root.render(<Navbar />);
  }
  
  disconnectedCallback() {
    if (this.root) {
      setTimeout(() => this.root.unmount(), 0);
    }
  }
}

if (!customElements.get('site-navbar')) {
  customElements.define('site-navbar', SiteNavbar);
}
